/* Stix PDP Stock-Aware Picker — Option A (Pills v2)
 * --------------------------------------------------
 * Builds chip groups for ALL dimensions in the merged product-family
 * catalog (window.stix_api.product.json). 5 dims on Stix set products
 * (Material, Bag, Hand, Flex, Length). */
(function () {
  'use strict';
  var ARM = 'a';

  function maybeInit() {
    var arm = window.STIX_TEST && window.STIX_TEST['pdp_stockaware_picker'];
    if (arm !== ARM) return;
    if (!window.StixPicker || !window.StixPicker.catalog) {
      setTimeout(maybeInit, 50);
      return;
    }
    init();
  }
  document.addEventListener('cl-picker-router:activated', function (e) {
    if (!e.detail || e.detail.arm !== ARM) return;
    maybeInit();
  });
  document.addEventListener('cl-picker-catalog-ready', maybeInit);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeInit);
  } else {
    maybeInit();
  }

  function init() {
    var root = document.querySelector('[data-cl-picker-A]');
    if (!root) return;
    if (root.dataset.clInited) return;
    root.dataset.clInited = '1';

    var catalog = StixPicker.catalog;
    var mount = root.querySelector('[data-cl-options-mount]');
    var oosMount = root.querySelector('[data-cl-oos-mount]');
    var oosHero = StixPicker.attachOosHero(oosMount, ARM);

    /* Build chip groups for every option in the merged catalog */
    var allVals = {};
    catalog.optionNames.forEach(function (name, i) {
      allVals[name] = [];
      catalog.variants.forEach(function (v) {
        if (v.options[i] && allVals[name].indexOf(v.options[i]) === -1) {
          allVals[name].push(v.options[i]);
        }
      });
    });

    mount.innerHTML = catalog.optionNames.map(function (name) {
      var vals = allVals[name];
      return '<div class="cl-picker-A__option" data-cl-option="' + name + '">' +
        '<div class="cl-picker-A__label"><span>' + name + '</span></div>' +
        '<div class="cl-picker-A__chips" data-cl-chips data-cl-option-name="' + name + '" data-count="' + vals.length + '">' +
        vals.map(function (v) {
          return '<button type="button" class="cl-chip" data-cl-chip data-cl-val="' + v.replace(/"/g, '&quot;') + '">' + v + '</button>';
        }).join('') +
        '</div>' +
        '</div>';
    }).join('');

    /* Seed selection from the URL ?variant param, or first available variant */
    var sel = StixPicker.initialSel();

    /* Quick Pick at top */

    function render() {
      root.querySelectorAll('[data-cl-chips]').forEach(function (group) {
        var optionName = group.getAttribute('data-cl-option-name');
        group.querySelectorAll('[data-cl-chip]').forEach(function (chip) {
          var val = chip.getAttribute('data-cl-val');
          chip.classList.remove('is-active', 'is-oos', 'is-not-offered');
          if (sel[optionName] === val) { chip.classList.add('is-active'); return; }
          if (!StixPicker.valueOffered(optionName, val)) { chip.classList.add('is-not-offered'); return; }
          var probe = StixPicker.probeStatus(sel, optionName, val);
          if (probe === 'not-offered') chip.classList.add('is-not-offered');
          else if (probe === 'oos') chip.classList.add('is-oos');
        });
      });

      var status = StixPicker.variantStatus(sel);
      var suggest = root.querySelector('[data-cl-suggest]');
      var suggestText = root.querySelector('[data-cl-suggest-text]');
      var swapBtn = root.querySelector('[data-cl-swap-btn]');
      if (status !== 'in-stock') {
        var closest = StixPicker.closestInStock(sel);
        if (closest) {
          var swaps = [];
          catalog.optionNames.forEach(function (name, i) {
            if (sel[name] && closest.variant.options[i] !== sel[name]) {
              swaps.push(name + ' → <strong>' + closest.variant.options[i] + '</strong>');
            }
          });
          suggestText.innerHTML = 'Closest in-stock combo: ' + swaps.join(', ') + '.';
          suggest.classList.add('is-open');
          swapBtn.onclick = function () { sel = Object.assign({}, closest.sel); applyAndFire(); };
        } else {
          suggest.classList.remove('is-open');
        }
      } else {
        suggest.classList.remove('is-open');
      }
      oosHero.update(sel, status);
    }

    function applyAndFire() {
      StixPicker.applyVariant(sel);
      StixPicker.fireVariantEvents(sel, ARM);
      render();
    }

    root.querySelectorAll('[data-cl-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('is-not-offered')) return;
        var group = chip.closest('[data-cl-chips]');
        sel[group.getAttribute('data-cl-option-name')] = chip.getAttribute('data-cl-val');
        applyAndFire();
      });
    });
    root.addEventListener('oos-hero:swap', function (e) {
      sel = Object.assign({}, e.detail.sel);
      applyAndFire();
    });

    render();
  }
})();
